









import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WPageError extends BaseComponent {
	@Prop({ type: [String, Object], required: true })
	message!: string;

	@Prop({ type: String, default: "error" })
	type!: string;

	@Prop({ type: Boolean, default: true })
	full!: boolean;
}
